import { base } from './base';
import { colors } from './colors';
import {
  accordion,
  breadcrumb,
  buttons,
  card,
  forms,
  links,
  navbar,
  paper
} from './components';
import { fonts, headings } from './typography';
import { LucidTheme } from 'types/types';

const theme: LucidTheme = {
  ...base,
  colors,
  ...fonts,
  accordion,
  breadcrumb,
  buttons,
  card,
  forms,
  headings,
  links,
  navbar,
  paper
};

export default theme;
